import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  coderCard:{
    codeHistoryCard: false,
    codeAssistWindowCard: true,
    codeBookCard: true
  }
};

const codeAssistSlicer = createSlice({
  name: "codeAssistSlicer",
  initialState,
  reducers: {
    setCodeHistoryCard: (state, action) => {
        state.coderCard.codeHistoryCard = action.payload;
    },
    setCodeAssistWindowCard: (state, action) => {
        state.coderCard. codeAssistWindowCard = action.payload;
    },
    setCodeBookCard: (state, action) => {
        state.coderCard.codeBookCard = action.payload;
    },
  },
});
export const { setCodeHistoryCard,   setCodeAssistWindowCard, setCodeBookCard } = codeAssistSlicer.actions;

export default codeAssistSlicer.reducer